//
// KPIElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "../../models/visualElements/KPIElement";
import "./KPICellController";
import "../../util/KPIGridLayoutMetrics";
import "@sas-dvr/ltjs-commons/styles/StyleChain";

var KPIElementController = createModule("BIRD::KPIElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    {
        KPI_LIMIT_EXCEEDED: 50008,
        INVALID_KPI_DISPLAY_RULES: 50009,
    },
    ,
    ,
    ,
    {
        getModel: [1],
        setShowAllVisuals: [0,2],
        getCellControllers: [[1]],
        getNumberOfKPIs: [3],
        showTooltip: [0,4,4],
        getMaximumNumberOfKPIs: [3],
        getSelectionStyleChain: [1],
        getMaxNumberOfVisuals: [3],
        computeKPIGridLayoutMetrics: [1,5,5,5,5],
        getKPIHeaderStyleChain: [1],
        getCategoryVariableName: [7],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default KPIElementController;
